<div class="row">
  <div class="col-lg-12">

    <div class="col-sm-12">
      <div class="row" id="divSummaryIndex">
        <div class="col-12  col-sm-7 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-yellow elevation-1"><i class="fas fa-calendar-alt"></i></span>
            <div class="info-box-content">
              <span class="info-box-number">Pending ({{today | date:'dd MMM'}})</span>
              <span class="info-box-text">{{PendingArticles}} Articles</span>
              <span class="info-box-text">{{PendingPages}} Pages</span>
              <!--<span class="info-box-text"> {{Batch}}</span>-->

            </div>
          </div>
        </div>

        <div class="col-12  col-sm-7 col-md-2">

          <div class="info-box mb-3">
            <span class="info-box-icon bg-red elevation-1"><i class="fas fa-calendar-plus"></i></span>
            <div class="info-box-content">
              <span class="info-box-number">Today ({{today | date:'yyyy'}})</span>
              <span class="info-box-text">{{TodayArticles}} Articles</span>
              <span class="info-box-text">{{TodayPages}} Pages</span>
              <!--<span class="info-box-text"> {{TodayBatch}}</span>-->

            </div>
          </div>
        </div>
        <div class="col-12  col-sm-7 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-orange elevation-1"><i class="fas fa-calendar-check"></i></span>
            <div class="info-box-content">
              <span class="info-box-number">Yesterday ({{yesterday | date:'dd MMM'}})</span>
              <span class="info-box-text">{{YesterdayArticles}} Articles</span>
              <span class="info-box-text">{{YesterdayPages}} Pages</span>

              <!--<span class="info-box-text"> {{YesterdayBatch}}</span>-->

            </div>
          </div>
        </div>
        <div class="col-12  col-sm-7 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-purple elevation-1"><i class="fas fa-calendar-day"></i></span>
            <div class="info-box-content">
              <span class="info-box-number">Current Month ({{today | date:'MMM'}})</span>
              <span class="info-box-text">{{CurrentMonthArticles}} Articles</span>
              <span class="info-box-text">{{CurrentMonthPages}} Pages</span>

              <!--<span class="info-box-text"> {{CurrentMonthBatchCount}}</span>-->

            </div>
          </div>
        </div>
        <div class="col-12  col-sm-7 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-green elevation-1"><i class="fas fa-calendar-week"></i></span>
            <div class="info-box-content">
              <span class="info-box-number">Previous Month ({{previousMonth | date:'MMM'}})</span>
              <span class="info-box-text">{{PreviousMonthArticles}} Articles</span>
              <span class="info-box-text">{{PreviousMonthPages}} Pages</span>

              <!--<span class="info-box-text"> {{PreviousMonthBatchCount}}</span>-->

            </div>
          </div>
        </div>
        <div class="col-12 col-sm-7 col-md-2">
          <div class="info-box">
            <span class="info-box-icon bg-blue elevation-1"><i class="fas fa-calendar"></i></span>
            <div class="info-box-content">
              <span class="info-box-number">Overall</span>
              <span class="info-box-text">{{OverAllArticles}} Articles</span>
              <span class="info-box-text">{{OverAllPages}} Pages</span>
              <!-- <span class="info-box-text"> {{OverAllBatch}}</span>-->
            </div>

          </div>
        </div>
      </div>


    </div>



    <div class="row">

      <div class="col-12">

        <!--<div class="card-header">-->
        <!--<div class="card-title"><h5>Completed</h5></div>-->
        <!--<div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>-->
        <!--</div>-->
        <div class="card-body" style="display: block;">
          <highcharts-chart [Highcharts]="highchartsCol"
                            [options]="chartOptionsCol"
                            [oneToOne]="false"
                            style="width: 100%; display: block;">
          </highcharts-chart>

        </div>
      </div>

    </div>
    <div class="row">

      <div class="col-12 text-center">
        <label class="lblBenchMarkData">{{this.modelItem.BenchMarkPages}}</label>
      </div>

    </div>
  </div>
</div>


